// extracted by mini-css-extract-plugin
module.exports = {"main":"newChannelModal_main__3AFJL","form":"newChannelModal_form__3fjc6","textarea":"newChannelModal_textarea__26ONu"};